// extracted by mini-css-extract-plugin
module.exports = {"container":"e_6u","floatingBox":"e_7u","floatingAd":"e_8u"};